import { Toaster as SonnerToaster, toast } from 'sonner';

/** Place once at the app root. Show messages with `toast.success('Saved')` / `toast.error(...)`. */
export function Toaster() {
  return (
    <SonnerToaster
      theme="light"
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast: 'border border-border bg-surface text-surface-foreground shadow-md rounded-lg',
          description: 'text-muted-foreground',
        },
      }}
    />
  );
}

export { toast };
